// Years
export const SET_YEARS = 'SET_YEARS';



// WEBPACK FOOTER //
// ./src/store/reducers/years/actionTypes.js